import React, { Component } from 'react';
import MixedGallery from '../stories/MixedGallery';
import BaseModal from '../components/BaseModal';
import { handlePrint } from './preview';
import PropTypes from 'prop-types';

class FilePreviewViewer extends Component {
  state = {
    showOrderPreview: false,
    orderPreviewUrl: null,
    orderFileName: null,
    fileType: 'pdf'
  };

  componentDidMount() {
    this.updateStateFromProps(this.props);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.blobUrl !== prevProps.blobUrl ||
      this.props.fileName !== prevProps.fileName ||
      this.props.fileType !== prevProps.fileType
    ) {
      this.updateStateFromProps(this.props);
    }
  }

  updateStateFromProps = (props) => {
    const { blobUrl, fileName, fileType } = props;
    if (blobUrl && fileName) {
      this.setState({
        showOrderPreview: true,
        orderPreviewUrl: blobUrl,
        orderFileName: fileName,
        fileType: fileType || 'pdf'
      });
    }
  };

  handleClosePreview = () => {
    if (this.state.orderPreviewUrl) {
      URL.revokeObjectURL(this.state.orderPreviewUrl);
    }
    this.setState({
      showOrderPreview: false,
      orderPreviewUrl: null,
      orderFileName: null,
      fileType: 'pdf'
    });
  };

  renderPreviewModal = () => {
    const { orderFileName, showOrderPreview, orderPreviewUrl, fileType } = this.state;

    return (
      <BaseModal
        title={orderFileName}
        visible={showOrderPreview}
        onCancel={this.handleClosePreview}
        width="80%"
        style={{ top: 30 }}
        footer={null}
        destroyOnClose
      >
        <MixedGallery
          files={[
            {
              type: fileType,
              fileUrl: orderPreviewUrl,
              originalTitle: orderFileName,
            },
          ]}
          showPrintButton={fileType === 'pdf'}
          closeComponent={this.handleClosePreview}
          handlePrint={handlePrint}
        />
      </BaseModal>
    );
  };

  render() {
    return <>{this.renderPreviewModal()}</>;
  }
}

FilePreviewViewer.defaultProps = {
  fileType: 'pdf',
  blobUrl: '',
  fileName: '',
};

FilePreviewViewer.propTypes = {
  fileType: PropTypes.string,
  blobUrl: PropTypes.string,
  fileName: PropTypes.string
};

export default FilePreviewViewer;
